module.exports = "/_next/static/images/mobilelending-line-49ce77261b401962fbfb1ea9db1b9d15.svg";